import { useCallback, useEffect, useMemo } from 'react';
import { SearchCollectionName } from 'api/search';
import { useLinkSearchStore } from 'components/tasks/utils/useLinkSearchStore';
import { useIsPending } from 'customHooks/useIsPending';
import { useSearch } from 'customHooks/useSearch';

const useLinkSearchResults = () => {
    const { query: rawQuery, setIsTypesensePending } = useLinkSearchStore();

    const [isPending, { query }] = useIsPending({
        query: rawQuery.replace('@', ' '),
    });

    const queryResults = useSearch({
        query,
    });

    useEffect(() => {
        setIsTypesensePending(isPending);
    }, [isPending, setIsTypesensePending]);

    return queryResults;
};

const useSearchResultsProps = <T extends SearchCollectionName>(resource: T) => {
    const { data } = useLinkSearchResults();
    const items = useMemo(() => data[resource], [data, resource]);
    const isEmpty = useMemo(() => !items || items.found === 0, [items]);
    const getKey = useCallback((key: string | number) => `${resource}-${key}`, [resource]);

    return {
        getKey,
        isEmpty,
        data: items,
    };
};

export { useLinkSearchResults, useSearchResultsProps };
